import { Component } from '@angular/core';
import { NavigationUIComponent, IconComponent, GenericLinkComponent } from '@spartacus/storefront';
import { NgTemplateOutlet, NgClass } from '@angular/common';
import { TranslatePipe } from '@spartacus/core';

@Component({
    selector: 'app-efa-navigation-ui',
    templateUrl: './efa-navigation-ui.component.html',
    imports: [IconComponent, NgTemplateOutlet, GenericLinkComponent, NgClass, TranslatePipe]
})
export class EfaNavigationUIComponent extends NavigationUIComponent {}
